export async function initiateTransfer(payload) {
  const res = await fetch(
    `${window.__AW_BASE_URL__}/api/v1/connected_account_transfers/create`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.__AW_BEARER__}`,
        "Content-Type": "application/json",
        "x-on-behalf-of": window.__AW_ON_BEHALF_OF__,
        "x-api-version": "2024-09-27",
      },
      body: JSON.stringify(payload),
    }
  );

  if (res.status !== 403) {
    const body = await res.text();
    throw new Error(
      `Expected SCA challenge (403). Got ${res.status}: ${body}`
    );
  }

  const scaSessionCode = res.headers.get("x-sca-session-code");

  if (!scaSessionCode) {
    throw new Error("Missing x-sca-session-code header");
  }

  return scaSessionCode;
}

export async function completeTransfer(payload, scaToken) {
  const res = await fetch(
    `${window.__AW_BASE_URL__}/api/v1/connected_account_transfers/create`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.__AW_BEARER__}`,
        "Content-Type": "application/json",
        "x-on-behalf-of": window.__AW_ON_BEHALF_OF__,
        "x-api-version": "2024-09-27",
        "x-sca-token": scaToken,
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await res.json();

  if (!res.ok) {
    throw data;
  }

  return data;
}